import { ChangeDetectionStrategy, Component, Input, SimpleChanges, ViewEncapsulation } from '@angular/core';

import { TCallbackFunc } from '../../../interfaces/core';
import { CommonBaseComponent } from '../../../base_component/base.component';
import { COMMON_LOADER_DEFAULT_DELAY_TIMEOUT } from '../../const/loader-default-delay-timeout';


@Component({
	selector: 'common-loader',
	templateUrl: './loader.component.pug',
	styleUrls: ['./loader.component.sass'],
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommonLoaderComponent extends CommonBaseComponent {
	@Input() isLoading: boolean = false; // Active or not
	@Input() hasDelay: boolean = false; // Delay before showing loader
	@Input() hasMinDuration: boolean = false; // Minimum loader display time
	@Input() label: string = ''; // Loaders text
	@Input() loaderClasses: string = ''; // CSS classes for loader
	@Input() loaderTopAligned: boolean = false; // Made align to top
	@Input() loaderWithOverlay: boolean = false; // With overlay

	isShow: boolean = false;
	isMinDurationOver: boolean = true;

	protected delayTimeout: number = 0;
	protected durationTimeout: number = 0;
	protected cancelDelayTimer: TCallbackFunc;
	protected cancelDurationTimer: TCallbackFunc;

	ngOnInit(): void {
		super.ngOnInit();

		this.willUnbind(() => this.cancelDelayTimer);
		this.willUnbind(() => this.cancelDurationTimer);
	}

	ngOnChanges(changes: SimpleChanges): void {
		super.ngOnChanges(changes);

		if (changes.hasDelay) {
			if (changes.hasDelay.currentValue) {
				this.delayTimeout = COMMON_LOADER_DEFAULT_DELAY_TIMEOUT;
			} else {
				this.delayTimeout = 0;
			}
		}

		if (changes.hasMinDuration) {
			if (changes.hasMinDuration.currentValue) {
				this.durationTimeout = COMMON_LOADER_DEFAULT_DELAY_TIMEOUT;
			} else {
				this.durationTimeout = 0;
			}
		}

		if (changes.isLoading) {
			if (changes.isLoading.currentValue) {
				if (this.hasDelay || this.hasMinDuration) {
					this.startLoader();
				} else {
					this.isShow = true;
					this.runUpdate();
				}
			} else {
				if (this.hasDelay || this.hasMinDuration) {
					this.stopLoading();
				} else {
					this.isShow = false;
					this.runUpdate();
				}
			}
		}
	}

	protected startLoader(): void {
		this.cancelDelayTimer = this.timeout(
			() => this.showLoader(),
			this.delayTimeout,
			() => this.cancelDelayTimer = null,
		);
	}

	protected showLoader(): void {
		this.isMinDurationOver = false;
		this.isShow = true;
		this.runUpdate();

		this.cancelDurationTimer = this.timeout(
			() => {
				this.isMinDurationOver = true;
				this.runUpdate();
			},
			this.durationTimeout,
			() => this.cancelDurationTimer = null,
		);
	}

	protected stopLoading(): void {
		if (this.cancelDelayTimer) {
			this.cancelDelayTimer();
		}

		this.isShow = false;
		this.runUpdate();
	}
}
